const TestComponent = ({text}: any) => {
    return (
        <div>
            Component: {text}
        </div>
    )
}

export default TestComponent;